import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IShopSchema } from "../../shared/types";

interface ICurrentBusinessMetaData {
  total_shops: number;
  name: string;
  best_performing_shop: string;
  gross_revenue: number;
  gross_profit: number;
  total_sales: number;
}

interface ICurrentBusiness {
  metaData: ICurrentBusinessMetaData;
  shops: IShopSchema[];
}

const initialState: ICurrentBusiness = {
  metaData: {
    total_shops: 0,
    name: "",
    best_performing_shop: "",
    gross_revenue: 0,
    gross_profit: 0,
    total_sales: 0,
  },
  shops: [],
};

type CurrentBusinessType = Partial<ICurrentBusiness>;

const currentBusiness = createSlice({
  name: "currentBusiness",
  initialState,
  reducers: {
    setCurrentBusinessMetadata: (
      state: CurrentBusinessType,
      action: PayloadAction<ICurrentBusinessMetaData>
    ) => {
      state.metaData = action.payload;
    },
    setCurrentBusinessShops: (
      state: CurrentBusinessType,
      action: PayloadAction<IShopSchema[]>
    ) => {
      state.shops = action.payload;
    },
  },
});

export const currentAdminbusinessActions = currentBusiness.actions;
// export const selectBusinessMetadata = (state)=>state.currentBusiness.metaData
// export const selectBusinessShop = (state)=>state.currentBusiness.shops

export default currentBusiness.reducer;
